import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  USER_ROLE_ADMIN,
  USER_ROLE_AGENT,
} from 'common/userRoles';

import SrAgentToursView from 'client/components/SrAgentToursView';
import SrAgentDashboardTabBar from 'client/components/SrAgentDashboardTabBar';

import {
  SCREEN_ID_AGENT_TOURS,
} from 'client/constants/screenIds';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedRoles, { getUserLandingPage } from 'client/helpers/allowedRoles';
import Navbar from 'client/components/Navbar';
import SrSettingsModal from 'client/components/SrSettingsModal';
import H1 from 'client/components/H1';

import AgentActions from 'client/actions/Agent';

@withTransitionHook
@allowedRoles({
  roles: [
    USER_ROLE_AGENT,
    USER_ROLE_ADMIN,
  ],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_AGENT_TOURS)
@withScrollToTop
@branch({
  currentUser: ['currentUser'],
  agentTours: ['agent', 'tours'],
})
class AgentToursPage extends Component {
  static fetchData(match, inject) {
    const agentUserId = match.params.agentUserId
      ? parseInt(match.params.agentUserId, 10)
      : inject.state.get(['currentUser', 'id']);

    return AgentActions.getAgentTours(inject, { agentUserId });
  }

  static getPageMetadata = () => ({
    pageTitle: 'Scheduled Tours | Sunroom Rentals',
    section: 'Admin',
  })

  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    agentTours: PropTypes.array,
  }

  constructor(props) {
    super(props);

    this.state = {
      showSettingsModal: false,
    };
  }

  _onSettingsClick = () => {
    this.setState({
      showSettingsModal: true,
    });
  }

  _onCloseSettingsModal = () => {
    this.setState({
      showSettingsModal: false,
    });
  }

  render() {
    const {
      currentUser,
      agentTours,
      match,
      history,
    } = this.props;

    const {
      showSettingsModal,
    } = this.state;

    const agentUserId = match.params.agentUserId
      ? parseInt(match.params.agentUserId, 10)
      : currentUser.id;

    return (
      <div className='page-agentDashboard'>
        <Navbar
          redirectLogoTo={getUserLandingPage({ userRoles: currentUser.roles })}
          rightButton={(
            <span
              className='settingsGear'
              onClick={this._onSettingsClick}
            />
          )}
        />
        <SrAgentDashboardTabBar />

        {/* Blank State for 0 tours */}
        {(!agentTours || agentTours.length === 0) && (
          <div className='contentContainer'>
            <div className='tourDayContainer'>
              <H1>{'Today\'s Tours (0)'}</H1>
            </div>
          </div>
        )}

        {agentTours && agentTours.length > 0 && (
          <SrAgentToursView agentUserId={agentUserId} history={history} />
        )}

        {showSettingsModal &&
          <SrSettingsModal
            isOpen={showSettingsModal}
            onClose={this._onCloseSettingsModal}
          />
        }
      </div>
    );
  }
}

AgentToursPage.displayName = 'AgentToursPage';

export default AgentToursPage;
